import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';

// Crear el tema personalizado
const customTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    minHeight: '40px',
                    backgroundColor: '#004aad', // Color azul del botón
                    borderRadius: '20px',
                    padding: '6px 20px',
                    color: 'white',
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&:hover': {
                        backgroundColor: '#003a8d', // Color más oscuro en hover
                        boxShadow: 'none',
                    },
                },
            },
        },
    },
});

function NavBtn({ children, color = 'primary', onClick, onMouseDown, ...props }) {
    return (
        <ThemeProvider theme={customTheme}>
            <Button
                size="large"
                variant="contained"
                color={color}
                onClick={onClick}
                onMouseDown={onMouseDown}
                {...props}
            >
                {children}
            </Button>
        </ThemeProvider>
    );
}

export default NavBtn;
